import React from 'react'
import conversationStyles from 'src/App/Pages/Inbox/Conversation/styles.css'
import styles from '../Vehicle/styles.css'

export default function NoChats() {
  return (
    <div className={conversationStyles.conversation}>
      <div className={styles.noMessages}>
        <h3>Selecciona una conversación</h3>
      </div>
    </div>
  )
}
